import styled from 'styled-components';

/** The explanation for the chosen suggestion, where the user is about to type. */
export const promptHint = styled.p`
    margin: 0 var(--space-sm) var(--space-xs);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.35;
    color: var(--color-text-subtle);
    text-align: start;
`;
